<div class="relative">
  <!-- Left Icon -->
  @if (config.showSearchIcon && config.iconPosition !== 'right') {
    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      @if (config.customIcon) {
        <i [class]="config.customIcon" class="text-gray-400 h-5 w-5"></i>
      } @else {
        <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
        </svg>
      }
    </div>
  }

  <!-- Input Field -->
  <input
    #searchInput
    type="text"
    [formControl]="searchControl"
    [placeholder]="config.placeholder || ''"
    [attr.aria-label]="config.ariaLabel || 'Search'"
    autocomplete="off"
    (focus)="handleFocus()"
    class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
    [ngClass]="{
      'pl-10': config.showSearchIcon && config.iconPosition !== 'right',
      'pr-10': config.showSearchIcon && config.iconPosition === 'right'
    }"
  />

  <!-- Right Icon -->
  @if (config.showSearchIcon && config.iconPosition === 'right') {
    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
      @if (config.customIcon) {
        <i [class]="config.customIcon" class="text-gray-400 h-5 w-5"></i>
      } @else {
        <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
        </svg>
      }
    </div>
  }

  <!-- Loading Indicator -->
  @if (isLoading) {
    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
      <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900"></div>
    </div>
  }

  <!-- Dropdown -->
  @if (isDropdownOpen && options.length > 0) {
    <div class="absolute z-[100] mt-1 bg-white rounded-md shadow-lg overflow-auto border border-gray-200"
         [ngStyle]="getDropdownStyles()">
      <ul class="py-1 max-h-60 overflow-y-auto">
        <ng-container *ngIf="config.multiSelect">
          <li class="px-4 py-2 flex items-center gap-2 cursor-pointer text-xs border-b border-gray-100 bg-gray-50 sticky top-0 z-10">
            <input type="checkbox"
                   class="mr-2"
                   [checked]="areAllOptionsSelected()"
                   (click)="$event.stopPropagation(); toggleSelectAll()"
            />
            <span class="font-semibold">Select All</span>
            <span class="ml-2 text-gray-500">({{ options.length }})</span>
          </li>
        </ng-container>
        @for (option of options; track option; let i = $index) {
          <li (mouseenter)="highlightedIndex = i"
              [class.bg-blue-50]="i === highlightedIndex"
              class="px-4 py-2 hover:bg-blue-50 flex items-center gap-2 cursor-pointer text-xs"
              (click)="handleCheckboxClick(option, $event)">
            <ng-container *ngIf="config.multiSelect">
              <input type="checkbox"
                     class="mr-2"
                     [checked]="isOptionChecked(option, i)"
                     (click)="$event.stopPropagation(); handleCheckboxClick(option, $event)"
              />
            </ng-container>
            <!-- Custom Template -->
            @if (hasItemTemplate() && config.itemTemplate) {
              <ng-container [ngTemplateOutlet]="config.itemTemplate" 
                           [ngTemplateOutletContext]="{ $implicit: option.item, displayText: option.displayText }">
              </ng-container>
            }
            <!-- Default Template -->
            @if (!hasItemTemplate()) {
              <span class="text-xs">{{ option.displayText }}</span>
            }
          </li>
        }
      </ul>
    </div>
  }

  <!-- No Results -->
  @if (isDropdownOpen && !isLoading && options.length === 0 && searchControl.value) {
    <div class="absolute z-[100] mt-1 bg-white rounded-md shadow-lg border border-gray-200"
         [ngStyle]="getNoResultsStyles()">
      <div class="px-4 py-2 text-sm text-gray-500">
        No results found
      </div>
    </div>
  }
</div>
